import { GlBadge, GlButton, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { gfm } from '../../../vue_shared/directives/gfm.js?vue3';
import { __ } from '~/locale';
import { confirmAction } from '../../../lib/utils/confirm_via_gl_modal/confirm_via_gl_modal.js?vue3';
import { createAlert } from '../../../alert.js?vue3';
import NoteHeader from './note_header.vue?vue3';
import NoteBody from './note_body.vue?vue3';
export default {
    name: 'DraftNote',
    components: {
        GlBadge,
        NoteHeader,
        NoteBody,
        GlButton
    },
    directives: {
        gfm,
        GlTooltip: GlTooltipDirective
    },
    inject: {
        store: {
            type: Object
        }
    },
    props: {
        draft: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            isDeleting: false,
            isSaving: false
        };
    },
    methods: {
        async onDelete () {
            const confirmed = await confirmAction(__('Are you sure you want to delete this comment?'), {
                primaryBtnVariant: 'danger',
                primaryBtnText: __('Delete comment')
            });
            if (!confirmed) return;
            this.isDeleting = true;
            try {
                await this.store.deleteDraft(this.draft);
            } catch (error) {
                createAlert({
                    message: __('Something went wrong while deleting your note. Please try again.'),
                    parent: this.$el
                });
            } finally{
                this.isDeleting = false;
            }
        },
        async saveNote (noteText) {
            this.isSaving = true;
            try {
                await this.store.updateDraft({
                    note: this.draft,
                    noteText
                });
                this.store.setEditingMode(this.draft, false);
            } finally{
                this.isSaving = false;
            }
        },
        onCancelEditing () {
            this.store.setEditingMode(this.draft, false);
        },
        startEditing () {
            this.store.setEditingMode(this.draft, true);
        }
    }
};
